module.exports = __webpack_public_path__ + "static/media/SoundCloud-Orange-Badge.ead04b57.png";